/**
 * Счётчик с глитч-эффектом (02_GPT-MODULAR).
 */

import { useState, useEffect } from "react";
import "./AnimatedCounter.css";

function AnimatedCounter() {
    const [count, setCount] = useState(263);
    const [glitchingDigits, setGlitchingDigits] = useState({});
    const [displayDigits, setDisplayDigits] = useState(['2', '6', '3']);
    
    useEffect(() => {
        // Увеличиваем реальный счетчик на 2 каждые 3 секунды
        const countInterval = setInterval(() => {
            setCount(prev => prev + 2);
        }, 3000);
        
        return () => clearInterval(countInterval);
    }, []);
    
    useEffect(() => {
        // Обновляем отображаемые цифры при изменении счетчика
        const digits = count.toString().split('');
        setDisplayDigits(digits);
    }, [count]);
    
    useEffect(() => {
        // Глитч эффект только для последней цифры каждые 2-3 секунды
        const glitchLastDigit = () => {
            const digitIndex = displayDigits.length - 1; // Последняя цифра
            const realDigit = displayDigits[digitIndex];
            
            setGlitchingDigits(prev => ({ ...prev, [digitIndex]: true }));
            
            // Быстрая смена цифр
            let iterations = 0;
            const glitchInterval = setInterval(() => {
                const randomDigit = Math.floor(Math.random() * 10).toString();
                setDisplayDigits(prev => {
                    const newDigits = [...prev];
                    newDigits[digitIndex] = randomDigit;
                    return newDigits;
                });
                
                iterations++;
                if (iterations >= 5) {
                    clearInterval(glitchInterval);
                    
                    // Возвращаем реальную цифру
                    setDisplayDigits(prev => {
                        const newDigits = [...prev];
                        newDigits[digitIndex] = realDigit;
                        return newDigits;
                    });
                    
                    setTimeout(() => {
                        setGlitchingDigits(prev => {
                            const newState = { ...prev };
                            delete newState[digitIndex];
                            return newState;
                        });
                    }, 300);
                }
            }, 80);
        };
        
        const interval = setInterval(() => {
            glitchLastDigit();
        }, 2500);
        
        return () => clearInterval(interval);
    }, [displayDigits]);
    
    return (
        <span className="counter-code">
            {displayDigits.map((digit, index) => (
                <span 
                    key={index} 
                    className={`counter-number ${glitchingDigits[index] ? 'counter-number_glitch' : ''}`}
                >
                    {digit}
                </span>
            ))}
            <span className="counter-number">+</span>
        </span>
    );
}

export default AnimatedCounter;
// components/AnimatedCounter/AnimatedCounter.js
